<template>
  <div>
    <ul class="date-tab">
      <li
        :class="{ current: dateTabCode == 1 }"
        @click="
          {
            dateTabCode = 1;
            time = '';
          }
        "
      >
        年维度
      </li>
      <li
        :class="{ current: dateTabCode == 2 }"
        @click="
          {
            dateTabCode = 2;
            time = '';
          }
        "
      >
        月维度
      </li>
      <li
        :class="{ current: dateTabCode == 3 }"
        @click="
          {
            dateTabCode = 3;
            time = '';
          }
        "
      >
        日维度
      </li>
      <li
        :class="{ current: dateTabCode == 4 }"
        @click="
          {
            dateTabCode = 4;
            time = '';
          }
        "
      >
        节假日
      </li>
    </ul>
    <div class="date-content">
      <Datepicker
        :inline="true"
        :language="zh"
        :maximumView="'year'"
        :minimumView="'year'"
        v-model="time"
        v-show="dateTabCode == 1"
        :disabled-dates="disabledDates"
      ></Datepicker>
      <Datepicker
        :inline="true"
        :language="zh"
        :maximumView="'month'"
        :minimumView="'month'"
        v-model="time"
        v-show="dateTabCode == 2"
        :disabled-dates="disabledDates"
      ></Datepicker>
      <Datepicker
        :inline="true"
        :language="zh"
        v-model="time"
        v-show="dateTabCode == 3"
        :disabled-dates="disabledDates"
      ></Datepicker>
      <Datepicker
        :inline="true"
        :language="zh"
        :maximumView="'month'"
        :minimumView="'month'"
        v-model="time"
        v-show="dateTabCode == 4"
        :disabled-dates="disabledDates"
      ></Datepicker>
      <div class="holiday" v-show="dateTabCode == 4">
        <div
          v-for="(item, index) in holidayList"
          :key="index"
          :class="{ current: holiday == item }"
          @click="holiday = item"
        >
          {{ item }}
        </div>
      </div>
      <div @click="getTime" class="date-sure">确定</div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { zh } from "vuejs-datepicker/dist/locale";

export default {
  name: "Datepicker_sp",
  components: {
    Datepicker
  },
  props: {
    holidayList: {
      type: Array,
      default() {
        return ["春节", "清明节", "劳动节"];
      }
    }
  },
  data() {
    return {
      dateTabCode: 2,
      zh: zh,
      time: "",
      holiday: "",
      disabledDates: {
        to: new Date(2011, 0, 0),
        from: new Date()
      }
    };
  },
  mounted() {},
  methods: {
    getTime() {
      if (!this.time) {
        if (!this.holiday) {
          this.$emit("postTime");
          return;
        }
      }
      var d = new Date(this.time);
      var datetime = "";
      if (this.dateTabCode == 1) {
        datetime = d.getFullYear();
      } else if (this.dateTabCode == 2) {
        datetime = d.getFullYear() + "-" + (d.getMonth() + 1);
      } else if (this.dateTabCode == 3) {
        datetime =
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      } else if (this.dateTabCode == 4 && this.holiday) {
        var list = document.getElementsByClassName("month__year_btn");
        datetime = list[list.length - 1].innerText + this.holiday;
      }
      this.dateBoxShow = false;
      this.time = "";
      this.holiday = "";
      this.$emit("postTime", datetime);
    }
  }
};
</script>

<style scoped lang="less">
.date-tab {
  width: 100%;
  height: 32px;
  li {
    cursor: pointer;
    width: 25%;
    height: 32px;
    line-height: 32px;
    float: left;
    background: #032f4f;
    border: 1px solid #0b689c;
  }
  .current {
    background: #0b689c;
  }
}
.date-content {
  width: 100%;
  position: absolute;
  left: 0;
  top: 32px;
  min-height: 32px;
  .holiday {
    width: calc(100% - 2px);
    height: 164px;
    background: #032f4f;
    position: absolute;
    left: 1px;
    bottom: 34px;
    > div {
      float: left;
      width: 33.33%;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0);
    }
    > div:hover {
      border: 1px solid #45badc;
    }
    .current {
      background: #45badc;
    }
  }
  .date-sure {
    width: 100%;
    height: 34px;
    line-height: 32px;
    background: #032f4f;
    border: 1px solid #0b689c;
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
  }
}
</style>
